const API_CONFIG = {
  baseUrl: process.env.REACT_APP_API_BASE_URL,
  stage: process.env.REACT_APP_API_STAGE,
};

export const getBaseUrl = () => {
  return API_CONFIG.baseUrl;
};

export const getStage = () => {
  return API_CONFIG.stage;
};

export const getFullBaseUrl = () => {
  if (API_CONFIG.stage && API_CONFIG.stage.trim() !== '') {
    return `${API_CONFIG.baseUrl}/${API_CONFIG.stage}`;
  }
  return API_CONFIG.baseUrl;
};
